import { Input } from '../ui/Input';
import { CountrySelect } from '../ui/CountrySelect';

interface SignupAgeFieldsProps {
  birthday: string;
  birthdayError: string;
  onBirthdayChange: (value: string) => void;
  country: string;
  onCountryChange: (value: string) => void;
  disabled: boolean;
}

/** Today as YYYY-MM-DD, in local time, for the date field's upper bound. */
const todayIso = (): string => {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${now.getFullYear()}-${month}-${day}`;
};

/**
 * Date of birth and the country it is judged against, shown only on the
 * sign-up tab. Both are required before an account can be created: the legal
 * drinking age runs from 16 to 21 depending on where someone is, so the
 * country is part of the check rather than a later profile detail.
 *
 * A real date input rather than a free-text MM/DD/YYYY field — this is the
 * most error-prone field in sign-up and the one that decides eligibility.
 */
export const SignupAgeFields = ({
  birthday,
  birthdayError,
  onBirthdayChange,
  country,
  onCountryChange,
  disabled,
}: SignupAgeFieldsProps) => (
  <>
    <CountrySelect
      label="Country"
      value={country}
      onChange={onCountryChange}
      helperText="We use this to apply the right legal drinking age."
      fullWidth
      required
      disabled={disabled}
    />

    <Input
      label="Date of Birth"
      type="date"
      value={birthday}
      onChange={(e) => onBirthdayChange(e.target.value)}
      max={todayIso()}
      error={birthdayError}
      success={birthday.length > 0 && !birthdayError}
      helperText="You must be of legal drinking age in your country."
      fullWidth
      required
      disabled={disabled}
    />
  </>
);
